import React from 'react';

import { MicrositeHeader } from '@latitude/microsite-header';

const DATA = [
  {
    id: 'home',
    label: 'Home',
    trackId: 'nav-home',
    href: '/credit-cards/gomastercard/'
  },
  {
    id: 'interest-free-offers',
    label: 'Interest Free offers',
    trackId: 'nav-interest-free-offers',
    href: '/credit-cards/gomastercard/interest-free-offers/'
  },
  {
    id: 'balance-transfer',
    label: 'Balance Transfer',
    trackId: 'nav-balance-transfer',
    href: '/credit-cards/balance-transfer/'
  },
  {
    id: 'faqs',
    label: 'FAQs',
    trackId: 'nav-faqs',
    href: '/credit-cards/gomastercard/faqs/'
  },
  {
    id: 'help',
    label: 'Help',
    trackId: 'nav-help',
    href: 'https://latitudefs.zendesk.com/hc/en-au/'
  }
];
const APPLY_NOW_URL = 'https://cards.latitudefinancial.com/go?promo_code=CSLE7FD9&source_code=IDAAA';

function GoMicrositeHeader({ applyNowUrl = APPLY_NOW_URL, data }) {
  return (
    <div
      css={`
        margin-top: 0 !important;
        background-color: #f8f8f8;
        [class^='MicrositeHeader__HeaderPlaceholder'] {
          height: 0;
        }
        .microsite-header {
          z-index: 2000 !important;
        }
      `}
    >
      <MicrositeHeader
        contentfulID={data?.id}
        data={data?.navItems || DATA}
        ctaHref={data?.cta?.url || applyNowUrl}
        trademark={data?.trademark !== false}
        microSiteName={data?.navTitle || 'GO Mastercard'}
      />
    </div>
  );
}

export default GoMicrositeHeader;
